// Helpers shared by the FW module views.

// One serial/revision per line, or separated by commas/semicolons.
export const parseSerialList = text =>
    String(text || '')
        .split(/[\n,;]+/)
        .map(item => item.trim())
        .filter(Boolean);

// Values occurring more than once, in first-seen order — duplicate serials in a
// pasted or CSV-imported list.
export const findDuplicateSerials = list => {
    const seen = new Set();
    const duplicates = new Set();

    list.forEach(item => {
        if (seen.has(item)) {
            duplicates.add(item);
        } else {
            seen.add(item);
        }
    });

    return Array.from(duplicates);
};

const IPV4_PARTS = /^(\d{1,3})\.(\d{1,3})\.(\d{1,3})\.(\d{1,3})$/;

// Zero-pad each IPv4 octet to 3 digits (10.20.30.40 -> 010.020.030.040), as the
// device's fixed-width IP field requires. Mirrors the backend FwIpService::pad.
export const padIpAddress = ip => {
    const value = String(ip ?? '').trim();

    if (!IPV4_PARTS.test(value)) {
        return ip;
    }

    return value
        .split('.')
        .map(octet => octet.padStart(3, '0'))
        .join('.');
};

export const formatFwDate = value => {
    if (value == null || value === '') return '';
    if (typeof value !== 'string') return String(value);

    const timestamp = value
        .trim()
        .toUpperCase()
        .replace(' ', 'T')
        .replace(/([+-]\d{2})(\d{2})$/, '$1:$2');
    const timestampPattern = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(?:\.\d+)?(?:Z|[+-]\d{2}:\d{2})?$/;
    if (!timestampPattern.test(timestamp)) return value;

    const calendarTimestamp = timestamp.slice(0, 19);
    const calendarDate = new Date(`${calendarTimestamp}Z`);
    if (
        Number.isNaN(calendarDate.getTime()) ||
        calendarDate.toISOString().slice(0, 19) !== calendarTimestamp
    ) {
        return value;
    }

    const timezoneOffset = timestamp.match(/(?:Z|[+-]\d{2}:\d{2})$/)?.[0] || 'Z';
    const date = new Date(`${calendarTimestamp}${timezoneOffset}`);

    return Number.isNaN(date.getTime()) ? String(value) : date.toISOString().slice(0, 19).replace('T', ' ');
};
